import ConfirmIdentity from 'features/auth/resetPassword/screens/ConfirmIdentity/ConfirmIdentity';
import React from 'react';

export default function Page() {
  return <ConfirmIdentity />;
}
